export default function promiseTimeout(interval, errorFactory) {
  return new Promise((resolve, reject) => {
    setTimeout(() => reject(errorFactory()), interval);
  });
}
